import { render, staticRenderFns } from "./lazyblock_buttons_link.vue?vue&type=template&id=7d58646b&scoped=true"
import script from "./lazyblock_buttons_link.vue?vue&type=script&lang=js"
export * from "./lazyblock_buttons_link.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_buttons_link.vue?vue&type=style&index=0&id=7d58646b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d58646b",
  null
  
)

export default component.exports